import domReady from '@wordpress/dom-ready';
import tippy from 'tippy.js';

domReady(() => {
	const mobilePriceListItemSelector = '.js-block-mobile-price-list-item';

	const mobilePriceListItems = document.querySelectorAll(`${mobilePriceListItemSelector}[data-tooltip]`);

	if (!mobilePriceListItems.length) {
		return;
	}

	mobilePriceListItems.forEach((item) => {
		tippy(item.querySelector('.typography'), {
			content: item?.dataset?.tooltip ?? '',
			animation: 'shift-away',
			theme: 'translucent productive',
			maxWidth: 240,
		});
	});
});
